import MuiAppBar from '@material-ui/core/AppBar';
import styled from '@material-ui/core/styles/styled';
import breakpoints from '../../theme/breakpoints';
import colors from '../../theme/colors';
import shadows from '../../theme/shadows';

export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: colors.white,
  color: colors.purpleDark,
  boxShadow: shadows.toolbar,
  height: breakpoints.toolbarHeight,
  ...(open && {
    width: `calc(100% - ${breakpoints.drawerWidth}px)`,
    marginLeft: `${breakpoints.drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const AnnouncementLabel = styled('div')(() => ({
  position: 'absolute',
  whiteSpace: 'nowrap',
  bottom: -5,
  left: '50%',
  background: colors.primary,
  color: colors.white,
  padding: '3px 7px',
  lineHeight: 1,
  fontSize: 12,
  borderRadius: 4,
  transform: 'translate(-55%, 2px)',
}));
